<template>
  <v-dialog v-model="uploadErrorDialog" max-width="790" width="530">
    <v-card class="delete-modal">
      <div class="v-card-title-text-container">
        <CloudSVG class="cloud-style" />
        <div>
          <v-card-title class="headline">Ups...</v-card-title>

          <v-card-text>
            {{ $t("PhotoUploadError") }}
            <br />
            <br />
            {{ specificErrorMessage }}
          </v-card-text>
        </div>
      </div>
      <v-card-actions>
        <div class="flex-grow-1"></div>

        <v-btn
          :ripple="false"
          class="cancel-button"
          text
          @click="closeDialog"
          >{{ $t("Cancel") }}</v-btn
        >

        <v-btn
          class="delete-button"
          text
          @click="closeDialog"
          @change="onFileChange"
        >
          <input class="photo-input" type="file" accept="image/*" title />
          {{ $t("TryAgain") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CloudSVG from "@/assets/logos/cloud.svg";
export default {
  name: "PhotoUploadError",
  components: { CloudSVG },
  props: ["toggleDialog", "specificErrorMessage"],
  data() {
    return {
      selectedPhoto: "",
      uploadErrorDialog: false
    };
  },
  methods: {
    onFileChange(e) {
      this.$parent.onFileChange(e);
    },
    closeDialog() {
      this.$parent.closeErrorDialog();
    }
  },
  watch: {
    toggleDialog(value) {
      this.uploadErrorDialog = value;
    }
  }
};
</script>

<style scoped>
.cloud-style {
  width: 100px;
  height: auto;
  margin: 20px;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.7));
}
.cloud-style * {
  fill: var(--primary-highlight);
}
.photo-input {
  opacity: 0;
  position: absolute;
  height: 100%;
  width: 100%;
}
.v-card-title-text-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Photos/PhotoUploadError.vue